import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/appointment.css"
import VehicleForm from "../Components/VehicleForm.js"
import CirclePlus from '../images/dbplus@3x.png'
import Modal from 'react-modal';
import Edit from 'react-icons/lib/fa/pencil';
import Trash from 'react-icons/lib/fa/trash';
import Wifi from 'react-icons/lib/fa/wifi';
import SpiffyBlue from '../images/spiffyblue.png'
import Iframe from 'react-iframe'
import AppointmentService from '../utils/AppointmentService.js';

//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export class MyGarageVehicle extends Component {
  constructor(props) {
    super(props)

    this.ApptService = new AppointmentService()
    this.state = {
      modalIsOpen: false,
      vehicle: this.props.vehicle,
      mileage_input: this.props.vehicle.mileage,
      isEditing: false,
      connectedCarModalOpen:false,
      showConfirmationModal: false,
      enterMileageModalOpen: false
    };
    this.closeModal = this.closeModal.bind(this)
    this.openModal = this.openModal.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    if(this.props.selectedVehicle && document.getElementById("vehicle"+ this.props.selectedVehicle.id)){
      document.getElementById("vehicle"+ this.props.selectedVehicle.id).style.backgroundColor = "#ff8c00"
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      vehicle: nextProps.vehicle,
    });
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }
  openModal() {
    this.setState({modalIsOpen: true});
  }
  openConnectedCar = () => {
    this.setState({
      connectedCarModalOpen:true
    })
  }
  editVehicle = () => {
    this.openModal()
    this.setState({
      isEditing: true
    })
  }
  deleteVehicle = () => {
    var vehicle = this.state.vehicle
    this.ApptService.updateVehicle(vehicle.year,vehicle.make,vehicle.model, vehicle.color,vehicle.vtype, vehicle.id, true)
    .then(res => {
      this.props.reloadGarage()
      this.setState({
        showConfirmationModal: false
      })
    })
    .catch(err => {
      throw new Error('Error deleting vehicle' + err.message);
    })
  }
  saveVehicle =(vehicle) => {
    this.setState({
      vehicle:vehicle
    })
    this.closeModal()
  }
  showConfirmation = () => {
    this.setState({
      showConfirmationModal: true
    })
  }
  closeConfirmationModal = () => {
    this.setState({
      showConfirmationModal: false
    })
  }
  closeMileageModal = () => {
    this.setState({
      enterMileageModalOpen: false
    })
  }
  editMileage = () => {
    this.ApptService.updateMileage(this.state.vehicle.id, this.state.mileage_input)
    .then(res => {

      this.setState({
        vehicle:res.vehicle,
        enterMileageModalOpen: false

      })
    })
    .catch(err => {
      throw new Error('Error deleting vehicle' + err.message);
    })
  }
  enterMileage = () => {
    this.setState({
      enterMileageModalOpen:true
    })
  }
  closeModal() {
    this.setState({modalIsOpen: false});
  }
  handleChange = event => {
    this.setState({mileage_input: event.target.value});
  }
  render() {
    const modalStyle =
    this.state.width < 780 ?
    {
      content: {
        top                   : '22.5%',
        left                  : '0%',
        height                : '55%',
        width                 : '100%',
        padding               : '10px',
        right                 : 'auto',
        backgroundColor       : '#134270',
        color                 : 'white',
      }
    }:
      {
        content: {
          top                   : '22.5%',
          left                  : '30%',
          height                : '55%',
          width                 : '40%',
          padding               : '10px',
          right                 : 'auto',
          backgroundColor       : '#134270',
          color                 : 'white',
        }
      }
      const modalStyle2 =
      this.state.width < 780 ?
      {
        content: {
          top                   : '30%',
          left                  : '0%',
          height                : '40%',
          width                 : '100%',
          padding               : '10px',
          right                 : 'auto',
          backgroundColor       : 'white',
          color                 : 'black',
        }
      }:
        {
          content: {
            top                   : '30%',
            left                  : '35%',
            height                : '40%',
            width                 : '30%',
            padding               : '10px',
            right                 : 'auto',
            backgroundColor       : 'white',
            color                 : 'black',
          }
        }
    var vehicleType = 'sedan'
    var vehicle = this.state.vehicle
    return (
      <div>
        <div className="vehicleGradient">
          { vehicle.spiffy_blue &&
            <img className ="blueImage" src={SpiffyBlue}></img>
          }
          <div className="column1">
            <img className="stockImageGarage"src={vehicle.stock_image_url} onError={(e)=>{e.target.onerror = null; e.target.src=`https://s3.amazonaws.com/spiffy-conductor-vehicle-images/generic/${vehicleType}.png`}}></img>
            <h6 className="vehicleDescription">{vehicle.year} {vehicle.make} {vehicle.model}</h6>
            <h6>{vehicle.mileage} mi <Edit className='fa-sm editButton' onClick={(e) => this.enterMileage(e)} /></h6>
          </div>
          <div className="column2">
            <Edit className='fa-sm editButton' onClick={(e) => this.editVehicle(e)} />
            <Trash className='fa-sm editButton' onClick={(e) => this.showConfirmation()} />
            {vehicle.is_connectable &&
              <a href={vehicle.connected_auth_url}><Wifi className='fa-sm editButton'/></a>
            }
          </div>
        </div>
        <Modal
          style={modalStyle}
          isOpen={this.state.modalIsOpen}
          contentLabel="Example Modal">
          <VehicleForm isEditing = {this.state.isEditing} id ={vehicle.id} make = {vehicle.make} model={vehicle.model} year = {vehicle.year} color={vehicle.color} selectVehicle = {this.saveVehicle} closeModal={this.closeModal}/>
        </Modal>
        <Modal
          style={modalStyle2}
          isOpen={this.state.showConfirmationModal}
          contentLabel="Example Modal">
          <h2 className="modalHeader">Remove Vehicle?</h2>
          <p>You are about to delete this vehicle From your account, are you sure you want to do this?</p>
          <div className="bottomButtons">
            <button onClick = {() => this.deleteVehicle()} className="btn successButtonFlex btn-block text-center" type="submit">Confirm</button>
            <button onClick = {() => this.closeConfirmationModal()}className="btn btn-block cancelButtonFlex text-center">Cancel</button>
          </div>
        </Modal>
        <Modal
          style={modalStyle2}
          isOpen={this.state.enterMileageModalOpen}
          contentLabel="Example Modal">
          <h2 className="modalHeader">Enter Current Mileage</h2>
          <input value={this.state.mileage_input} onChange={this.handleChange} className="promoInput"></input>
          <div className="bottomButtons">
            <button onClick = {() => this.editMileage()} className="btn successButtonFlex btn-block text-center" type="submit">Confirm</button>
            <button onClick = {() => this.closeMileageModal()}className="btn btn-block cancelButtonFlex text-center">Cancel</button>
          </div>
        </Modal>

      </div>
    )
  }
}
export default MyGarageVehicle



// WEBPACK FOOTER //
// ./src/Components/MyGarageVehicle.js